import React from 'react'
import Slider from 'rc-slider'
import 'rc-slider/assets/index.css'

import PropTypes from 'prop-types'

import { InputSection, RangeWrapper, HistogramPlaceholder } from './styles'
import InputLine from 'client/components/InputLine'

const PriceRangeHistogramPlaceholder = ({
  min = 0,
  max = 100,
  lowerBound = 0,
  upperBound = 100,
}) => (
  <>
    <RangeWrapper isLoading>
      <HistogramPlaceholder />
      <Slider range min={lowerBound} max={upperBound} value={[min, max]} disabled />
    </RangeWrapper>

    <InputSection isLoading>
      <InputLine name="minPriceHistogram" label="Min." value={`${min}`} type="text" disabled />
      <InputLine name="maxPriceHistogram" label="Max." value={`${max}`} type="text" disabled />
    </InputSection>
  </>
)

PriceRangeHistogramPlaceholder.propTypes = {
  max: PropTypes.number,
  min: PropTypes.number,
  lowerBound: PropTypes.number,
  upperBound: PropTypes.number,
}

export default PriceRangeHistogramPlaceholder
